import { Component, Input, SimpleChanges } from '@angular/core';
import { NavController, NavParams, LoadingController, ModalController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { ReservationsServices } from '../services';
import { CompCreateReservationPage } from '../../components/popups/create-reservation/create-reservation';

@Component({
    selector: 'page-reservation-pending-list',
    templateUrl: 'reservation-pending-list.html',
})
export class ReservationPendingListPage {
    @Input() reservations_pending;
    @Input() reservation_config;
    pending_reservations: any;
    pending_reservations_keys: any = [];

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        public reservationsServices: ReservationsServices,
        public modalCtrl: ModalController) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.reservations_pending) {
            this.pending_reservations = changes.reservations_pending.currentValue;
            this.pending_reservations_keys = Object.keys(this.reservationsServices.reservations_pending);
        }
    }

    openReservation(reservation) {
        let profileModal = this.modalCtrl.create(CompCreateReservationPage, {
            update_state: true,
            reservation: reservation,
            reservation_config: this.reservation_config
        });
        profileModal.present();
    }

    btnClass(state) {
        let cssClasses = {};
        switch (state) {
            case 'pending':
                cssClasses = {
                    'btn-outline-pending': true
                }
                break;
            case 'accepted':
                cssClasses = {
                    'btn-outline-accepted': true
                }
                break;
            case 'in_table':
                cssClasses = {
                    'btn-outline-in-table': true
                }
                break;
            case 'finished':
                cssClasses = {
                    'btn-outline-finished': true
                }
                break;
            case 'denied':
                cssClasses = {
                    'btn-outline-denied': true
                }
                break;
            case 'not_presented':
                cssClasses = {
                    'btn-outline-not-presented': true
                }
                break;
            case 'queue':
                cssClasses = {
                    'btn-outline-queue': true
                }
                break;
            case 'anulated':
                cssClasses = {
                    'btn-outline-denied': true
                }
                break;
        }
        return cssClasses;
    }
}



// WEBPACK FOOTER //
// ./src/pages/reservation/reservation-pending-list/reservation-pending-list.ts